import { render, staticRenderFns } from "./returns_management_panel.vue?vue&type=template&id=165910d7&scoped=true&"
import script from "./returns_management_panel.vue?vue&type=script&lang=js&"
export * from "./returns_management_panel.vue?vue&type=script&lang=js&"
import style0 from "./returns_management_panel.vue?vue&type=style&index=0&id=165910d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165910d7",
  null
  
)

export default component.exports